import LabServiceModel from "@/models/LabServiceModel";

export default class SampleAnalytesModel extends LabServiceModel {
  modelName() {
    return 'sample-analytes';
  }
  icon() {
    return 'eye-dropper';
  }
  defaults() {
    return {
      id: null,
      sample_id: null,
      analyte_id: null,
      created_at: null,
      created_by: null,
      updated_at: null,
      updated_by: null,
      deleted_at: null,
      sample: null,
      analyte: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      sample_id: (val) => (this.nullStringMutator(val)),
      analyte_id: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      created_by: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      updated_by: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
}
